export default __webpack_public_path__ + "a2d889fed8de6d2e4ca193b2e69d325a.png";